import { ActionBase } from '../../../core/store/action/ActionBase';

export const GET_USER_CURRENT_STATUS = '[Customer] Get User Current Status';

export class GetUserCurrentStatusAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_USER_CURRENT_STATUS;

  constructor(public payload: { userKey: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/GetUserCurrentStatusAction.ts